import { showNotification } from '@mantine/notifications'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { api } from '..'

export const editSmsRecipient = (
  alertRuleId: string,
  recipientId: string,
  phoneNumber: string,
) =>
  api.put(`/v1/alert-rules/${alertRuleId}/sms-recipients/${recipientId}`, {
    phoneNumber,
  })

export const useEditSmsRecipient = (alertRuleId: string) => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: ({
      recipientId,
      phoneNumber,
    }: {
      recipientId: string
      phoneNumber: string
    }) => editSmsRecipient(alertRuleId, recipientId, phoneNumber),
    onSuccess: () => {
      queryClient.invalidateQueries(['alertRule', alertRuleId, 'smsRecipients'])
      showNotification({
        message: 'SMS recipient updated successfully',
        color: 'green',
      })
    },
    onError: () => {
      showNotification({
        message: 'Failed to update SMS recipient',
        color: 'red',
      })
    },
  })
}
